import { Wrapper } from './DetailsSectionWrapper.styled'

const DetailsSectionWrapper: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>
}

export default DetailsSectionWrapper
